import {
  FormControl,
  InputLabel,
  MenuItem,
  Select as MuiSelect,
  SxProps,
  Theme,
  ThemeProvider,
} from '@mui/material';
import { selectThemePrimary, selectThemeSecondary } from '../../theme';

export type SelectProps<T extends string | number> = {
  id: string;
  label: string;
  value: T;
  disabled?: boolean;
  onChange: (newValue: T) => void;
  options: { value: T; label: string }[];
  size?: 'medium' | 'small';
  className?: string;
  sx?: SxProps<Theme>;
  color?: 'primary' | 'secondary';
};

export function Select<T extends string | number>({
  id,
  label,
  value,
  disabled,
  onChange: onChangeCb,
  options,
  size,
  sx,
  className,
  color = 'primary',
}: SelectProps<T>): JSX.Element {
  return (
    <ThemeProvider
      theme={color === 'primary' ? selectThemePrimary : selectThemeSecondary}
    >
      <FormControl fullWidth size={size}>
        <InputLabel id={id}>{label}</InputLabel>
        <MuiSelect
          disabled={disabled}
          labelId={id}
          id={id}
          value={value}
          label={label}
          onChange={(e) => onChangeCb(e.target.value as T)}
          variant="outlined"
          sx={sx}
          className={className}
          defaultValue={value}
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </MuiSelect>
      </FormControl>
    </ThemeProvider>
  );
}
